// extracted by mini-css-extract-plugin
export default {"logo-container":"UHGOiBqk5WSuZ4qoriwx","title":"StK6JLrTPI44Gs3u6wVC"};